import { DOMAIN_TYPE_CHAT_THREAD } from '../../../consts';
/**
 * Returns the thread id from the state, or null
 * @param state
 */
export var getThreadId = function (state) {
    var threadObject = state.domain[DOMAIN_TYPE_CHAT_THREAD];
    if (!threadObject) {
        return null;
    }
    var threads = Object.keys(threadObject);
    if (threads.length > 0) {
        return threads[threads.length - 1];
    }
    return null;
};
